import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import TestimonialsDisplayer from "../../Components/Tracks/TestimonialsDisplayer";
import notAvilable from '../../assets/ClientsImages/userImageNotAvilable.png';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
}))

const OurClients = ({ successStories }) => {

    const classes = useStyles();

    const [data, setData] = useState([]);

    useEffect(() => {
        setData(prepareDataForSuccessStories());
    }, [successStories])

    const prepareDataForSuccessStories = () => {
        return successStories
        .map((successStory) => {
            return {
                prevCompany: successStory.companyLogo,
                currCompany: successStory.toCompanyLogo,
                body: successStory.description,
                clientLogo: successStory.profileImage ? successStory.profileImage :  notAvilable,
                expertName: successStory.name,
                expertDesignation: successStory.profile,
                videoPath: successStory.videoURL
            }
        })
    }

    return (
        <TestimonialsDisplayer
            data={data}
            className={classes.root}
            title={'100% of our clients were successfully placed'}
        />
    )
}

export default OurClients;